import { CaseType } from 'modules/case-tracking/types/case-tracking.types';
import styles from './case-instruction-summary.module.scss';
import { Typography } from '@sanlam-glacier/app-common/components';
import { formatDateAsString } from 'utils/string-handling/human-readable-text';

interface CaseInstructionSummaryProps {
  caseDetails: CaseType;
}

export const CaseInstructionSummary = ({ caseDetails }: CaseInstructionSummaryProps) => {
  return (
    <div className={styles.instructionSummaryContainer}>
      <Typography
        color={Typography.COLOR.DEFAULT}
        variant={Typography.VARIANT.H4}
        weight={Typography.WEIGHT.MEDIUM}
        className={styles.summaryHeading}
        data-testid={'summaryHeading'}
      >
        Instruction summary
      </Typography>

      <div className={styles.grid}>
        <div className={styles.labelColumn}>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryClientLabel'}
          >
            Client name
          </Typography>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryIdNumberLabel'}
          >
            ID number
          </Typography>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryCreatedLabel'}
          >
            Created
          </Typography>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryInstructionTypeLabel'}
          >
            Instruction type
          </Typography>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summarySubTypeLabel'}
          >
            Sub type
          </Typography>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryProposalNumberLabel'}
          >
            Proposal number
          </Typography>
          <Typography
            className={styles.label}
            color={Typography.COLOR.TERTIARY}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryPlanNumberLabel'}
          >
            Investment plan number
          </Typography>
        </div>

        <div className={styles.valueColumn}>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryClientValue'}
          >
            {caseDetails.clientName ? caseDetails.clientName : '-'}
          </Typography>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryIdNumberValue'}
          >
            {caseDetails.clientId ? caseDetails.clientId : '-'}
          </Typography>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryCreatedValue'}
          >
            {caseDetails.created ? formatDateAsString(new Date(caseDetails.created)) : '-'}
          </Typography>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryInstructionTypeValue'}
          >
            {caseDetails.instructionType ? caseDetails.instructionType : '-'}
          </Typography>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summarySubTypeValue'}
          >
            {caseDetails.instructionCategory ? caseDetails.instructionCategory : '-'}
          </Typography>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryProposalNumberValue'}
          >
            {caseDetails.proposalNumber ? caseDetails.proposalNumber : '-'}
          </Typography>
          <Typography
            className={styles.value}
            color={Typography.COLOR.DEFAULT}
            variant={Typography.VARIANT.B4}
            data-testid={'summaryPlanNumberValue'}
          >
            {caseDetails.investmentNumber ? caseDetails.investmentNumber : '-'}
          </Typography>
        </div>
      </div>
    </div>
  );
};
